export default {
  namespaced: true,

  state: {
    tries: {},
  },

  getters: {
    getTries: state => key => state.tries[key],
  },

  actions: {
    init({ commit, state }, key) { !state.tries[key] && commit('INIT', key) },
    increase({ commit }, key) { commit('INCREASE', key) },
  },

  mutations: {
    INIT(state, key) { state.tries[key] = 1 },
    INCREASE(state, key) { state.tries[key]++ },
  },
}
